import { ReactNode, useEffect, useState } from 'react'
import Lottie from 'react-lottie-player'

export default function ErrorScreenTopArea({
  title,
  content,
}: {
  title: string
  content?: ReactNode | null
}) {
  const [errorAnimationData, setErrorAnimationData] = useState<
    object | undefined
  >(undefined)
  useEffect(() => {
    import('../../animation/error.json').then(setErrorAnimationData, () => {
      console.warn('import error.json error')
    })
  }, [])

  return (
    <div className="container mt-navbarSpacing text-center">
      {errorAnimationData ? (
        <Lottie
          className="mt-l mb-0 mx-auto"
          play
          loop={false}
          animationData={errorAnimationData}
          style={{ width: 180, height: 180 }}
        />
      ) : (
        <div style={{ height: 180 }} />
      )}
      <p className="babu-text-subtitle text-text600 mb-xs">{title}</p>
      {content || null}
    </div>
  )
}
